var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.actualComponent,{tag:"component",staticClass:"bg-white border-solid border-gray-300 hover:border-primary-lighter focus:border-primary-lighter border rounded-md flex items-center justify-center h-9 w-9 md:h-11 md:w-11",class:{
    'bg-[#50c0ff1a] cursor-auto pointer-events-none border-[#50C0FF]': _vm.active,
    'hover:border-gray-300 cursor-auto pointer-events-none !text-gray-300':
      _vm.disabled,
  },attrs:{"to":_vm.to},on:{"click":_vm.linkClicked}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }